export default __webpack_public_path__ + "static/media/2019-constructie-1.298c752b.jpeg";